export enum SharedBounceModalContentTypes {
    SIGNUP = "SIGNUP",
    PROMOTION = "PROMOTION",
}
